import { Emoji } from './emoji.js'
export * from './emoji.js'

export default Emoji
